import React, { useState } from "react";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Box, Typography, IconButton } from "@mui/material";
import useStyles from "./styles";

const CustomModal = ({ isOpen, onClose, files = [], title }) => {
  const classes = useStyles();
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!isOpen || files.length === 0) return null;

  const currentFileUrl = files[currentIndex].url;
  const currentFileName = files[currentIndex].file_name;

  // Helper to check if file is PDF
  const isPdf = (fileName) => {
    return fileName.toLowerCase().endsWith(".pdf");
  };

  const handleDownload = () => {
    if (!currentFileUrl) return;
    window.open(currentFileUrl, "_blank", "noopener,noreferrer");
  };

  const goPrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? files.length - 1 : prev - 1));
  };

  const goNext = () => {
    setCurrentIndex((prev) => (prev === files.length - 1 ? 0 : prev + 1));
  };

  return (
    <div className={classes.overlay}>
      <div className={classes.modal}>
        {/* Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          bgcolor="#333"
          color="#fff"
          p={2}
        >
          <Typography variant="h6" className={classes.heading}>
            {currentFileName} ({currentIndex + 1}/{files.length})
          </Typography>

          <Box display="flex" gap={2}>
            <ArrowDownwardIcon
              style={{ cursor: "pointer" }}
              onClick={handleDownload}
            />
            <CloseIcon style={{ cursor: "pointer" }} onClick={onClose} />
          </Box>
        </Box>

        {/* Content with navigation */}
        <Box
          position="relative"
          display="flex"
          alignItems="center"
          justifyContent="center"
          sx={{ width: "100%", minHeight: "80vh" }}
        >
          {files.length > 1 && (
            <>
              <IconButton
                onClick={goPrev}
                sx={{
                  position: "absolute",
                  left: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                  bgcolor: "#fff",
                }}
              >
                <ArrowBackIosIcon />
              </IconButton>
              <IconButton
                onClick={goNext}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                  bgcolor: "#fff",
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </>
          )}

          {isPdf(currentFileName) ? (
            <iframe
              src={currentFileUrl}
              title="PDF preview"
              style={{ width: "100%", height: "80vh", border: "none" }}
            />
          ) : (
            <img
              src={currentFileUrl}
              alt="Modal content"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
            />
          )}
        </Box>
      </div>
    </div>
  );
};

export default CustomModal;
